<div class="flex w-full gap-x-2" [class.mb-2]="!last">
  @if (!isImport) {
    <div class="w-3/12" tuiGroup [collapsed]="true">
      <app-autocomplete
        label="Грузовое место"
        [labelOutside]="false"
        class="tui-group__inherit-item w-8/12 tui-group__auto-width-item"
        componentClass="tui-group__inherit-item"
        [formControl]="
          cargoPlaceDetailsForm.controls.cargoPlaceJson.controls.code
        "
        [items]="catalogs.cargoPlaces$ | async"
        [itemValue]="'code'"
        [itemText]="'name'"
        [displayValue]="'name'"
        [itemSearch]="'search'"
      ></app-autocomplete>
      <tui-input-number
        [formControl]="cargoPlaceQuantityLimit"
        class="w-4/12 tui-group__auto-width-item"
        tuiTextfieldSize="m"
      ></tui-input-number>
    </div>
  }
  <div class="flex mt-2.5">
    <app-checkbox
      [formControl]="cargoPlaceDetailsForm.controls.box"
      [tuiHint]="box"
    ></app-checkbox>
    <ng-template #box> Коробки</ng-template>
  </div>
  <div [class]="isImport ? 'w-9/12' : 'w-5/12'">
    @if (hasBox$ | async) {
      <div class="flex gap-x-2">
        <div class="w-10/12" tuiGroup [collapsed]="true">
          <app-autocomplete
            label="Код"
            class="tui-group__inherit-item w-5/12 tui-group__auto-width-item"
            componentClass="tui-group__inherit-item"
            [labelOutside]="false"
            [formControl]="
              cargoPlaceDetailsForm.controls.packageTypeJson.controls.code
            "
            [items]="catalogs.packageTypes$ | async"
            [itemValue]="'code'"
            [itemText]="'code'"
            [itemSearch]="'search'"
          ></app-autocomplete>
          <tui-input
            [formControl]="
              cargoPlaceDetailsForm.controls.packageTypeJson.controls.name
            "
            class="w-auto"
            tuiTextfieldSize="m"
            [tuiTextfieldPostfix]="
              '(' +
              (
                cargoPlaceDetailsForm.controls.packageQuantityLimit.getRawValue() ??
                0
              ).toString() +
              ')'
            "
            >Описание</tui-input
          >
          @if (!cargoPlaceDetailsForm.controls.factPackageTypesJson.length) {
            <button
              (click)="addFactPackage()"
              class="tui-group__auto-width-item"
              tuiIconButton
              icon="tuiIconLayers"
              size="m"
            ></button>
          }
        </div>
        <tui-input-number
          [precision]="0"
          class="w-2/12"
          tuiTextfieldSize="m"
          [formControl]="cargoPlaceDetailsForm.controls.packageQuantity"
          >Кол-во упаковки</tui-input-number
        >
      </div>

      @if (cargoPlaceDetailsForm.controls.factPackageTypesJson.length) {
        <div class="mt-2">
          @for (
            factPackageTypeForm of cargoPlaceDetailsForm.controls
              .factPackageTypesJson.controls;
            track $index;
            let last = $last
          ) {
            <app-fact-package-type-form
              [last]="last"
              [cargoPlaceId]="cargoPlaceJson.controls.id.value"
              (create)="addFactPackage()"
              (remove)="removeFactPackage($index)"
              [factPackageTypeForm]="factPackageTypeForm"
            ></app-fact-package-type-form>
          }
          @if (
            cargoPlaceDetailsForm.controls.factPackageTypesJson.hasError(
              FACT_PACKAGE_QUANTITY_GREATER_THAN_ESTIMATED
            )
          ) {
            <div class="bg-red-500 rounded-xl text-white p-2">
              {{
                cargoPlaceDetailsForm.controls.factPackageTypesJson.getError(
                  FACT_PACKAGE_QUANTITY_GREATER_THAN_ESTIMATED
                )
              }}
            </div>
          }
        </div>
      }
    }
  </div>
  <div class="w-2/12">
    <tui-input-number
      tuiTextfieldSize="m"
      [formControl]="cargoPlaceDetailsForm.controls.cargoPlaceQuantity"
      >Кол-во</tui-input-number
    >
    @if (cargoPlaceDetailsForm.controls.factPackageTypesJson.length) {
      <div class="mt-2">
        <tui-input-number
          tuiTextfieldSize="m"
          [formControl]="cargoPlaceDetailsForm.controls.factCargoPlaceQuantity"
          >Σ Факт.</tui-input-number
        >
      </div>
    }
  </div>
</div>
